import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../../utils/auth';


const UserInvite = () => {
  const { t, i18n } = useTranslation();
  const [emailList, setEmailList] = useState([{ email: "" }]);

  const handleEmailChange = (index, value) => {
    const updatedList = [...emailList];
    updatedList[index].email = value;
    setEmailList(updatedList);
  };

  const addEmailField = () => {
    setEmailList([...emailList, { email: "" }]);
  };

  const removeEmailField = (index) => {
    const updatedList = emailList.filter((_, i) => i !== index);
    setEmailList(updatedList);
  };

  const sendInvitations = async () => {
    const emailIds = emailList.map((item) => item.email).filter((email) => email.trim());
    if (emailIds.length === 0) {
      toast.error(t('Please enter at least one valid email.'));
      return;
    }

    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/user/invite`,
        { emailIds },
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setEmailList([{ email: "" }]);
      toast.success(response?.data?.message || 'Invitation sent successfully!');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to send invitation. Please try again.');
    }
  };
 
  return (
    <>
<Toaster
  position="top-right"
  reverseOrder={false}
/>
      <Container className='p-2'>
        <Row>
          <Col lg="12">
            <Card>
              <Card.Header>
                <h4 className="card-title">{t('invite_a_friend')}</h4>
              </Card.Header>
              <Card.Body>
                <Form>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Form.Label style={{ fontSize: "16px", fontWeight: "500" }}>
                      {t('email_label')}
                    </Form.Label>
                    <Button variant="success" onClick={addEmailField}>
                      + {t('add')}
                    </Button>
                  </div>

                  {emailList.map((item, index) => (
                    <Form.Group
                      className="d-flex align-items-center gap-3 mb-2"
                      key={index}
                    >
                      <Form.Control
                        type="email"
                        placeholder={t('email_placeholder')}
                        value={item.email}
                        onChange={(e) => handleEmailChange(index, e.target.value)}
                        required
                      />
                      {emailList.length > 1 && (
                        <Button
                          variant="danger"
                          onClick={() => removeEmailField(index)}
                        >
                          -
                        </Button>
                      )}
                    </Form.Group>
                  ))}

<div className="d-flex justify-content-center mt-4">
                    <Button
                      variant="primary"
                      onClick={sendInvitations}
                      disabled={emailList.every((item) => !item.email.trim())}
                    >
                      {t('send_invitation')}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UserInvite;
